<template>
  <div class="main-container">
    <div class="login-register">
      <div>
        <div class="header">建议与反馈</div>

        <!-- 反馈分类 -->
        <div class="form-group">
          <label for="feedback-type">反馈类型</label>
          <div id="feedback-type">
            <select v-model="feedbackData.type">
              <option value='功能改进' selected>功能改进</option>
              <option value='界面优化'>界面优化</option>
              <option value='新增功能'>新增功能</option>
            </select>
          </div>
        </div>

        <!-- 详细描述 -->
        <div class="form-group">
          <label for="feedback-description">详细描述</label>
          <textarea id="feedback-description" v-model="feedbackData.description" placeholder="请详细描述您的建议与反馈，200字以内"
            rows="6" maxlength="200"></textarea>
        </div>

        <!-- 上传附件 -->
        <div class="form-group file-upload">
          <label>上传附件</label>
          <input type="file" @change="handleFileUpload" accept=".jpg,.png,.gif,.pdf,.doc,.docx" id="file-upload">
          <div class="tips">请上传jpg、png、gif、pdf、doc、docx格式，大小不超过2M</div>
          <i class="iconfont icon-shanchu" id="icon" @click="clearFile"></i>
        </div>

        <div class="alertMessage">
          {{ alertMessage }}
        </div>

        <!-- 提交按钮 -->
        <button @click="submitFeedback">提交反馈</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeedBack",
};
</script>

<script setup>

import { reactive, ref } from "vue";
import { feedBack } from "@/api/index";

import Toast from "@/utils/toast";

import { useUserStore } from '@/store/user';

import { useRouter } from "vue-router";
const router = useRouter();



const userStore = useUserStore();

let feedbackData = reactive({
  type: '功能改进',
  description: '',
  file: null
});

let alertMessage = ref('');

function submitFeedback() {
  if (feedbackData.description.trim() === '') {
    Toast("请填写反馈内容");
    return;
  } else {

    const formData = new FormData();
    formData.append('nickname', userStore.nickname);
    formData.append('type', feedbackData.type);
    formData.append('description', feedbackData.description);
    formData.append('file', feedbackData.file);


    feedBack(formData).then(res => {
      if (res.data.code === 200) {
        // Toast("反馈成功, 感谢您的宝贵意见");
        Toast('反馈成功, 感谢您的宝贵意见!', 'displayZone', 50, 1000, true);
        clearForm();
        router.push({ name: "home" });
      } else if (res.data.code === 500) {
        Toast("服务器错误，请稍后再试");
      }
    }).catch(err => {
      Toast("网络错误，请稍后再试");
    });
  }
}

function handleFileUpload() {
  const file = document.getElementById('file-upload').files[0];
  // 1、文件大小限制
  if (file.size > 2 * 1024 * 1024) {
    feedbackData.file = null;
    alertMessage.value = '*文件大小不能超过2M';
    return;
  } else {
    // 2、文件格式限制
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    if (!allowedTypes.includes(file.type)) {
      feedbackData.file = null;
      alertMessage.value = '*请上传jpg、png、gif、pdf、doc、docx格式的文件';
      return;
    } else {
      feedbackData.file = file;
      alertMessage.value = '';
    }
  }

}
function clearFile() {
  document.getElementById('file-upload').value = '';
}
function clearForm() {
  // feedbackData.type = '';
  feedbackData.description = '';
  feedbackData.file = null
}








// ~~~~~~~~~~~~ 公共函数 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
</script>

<style scoped>
.main-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - var(--header-height));
  background-color: #ecf0f3;
}

.login-register {
  display: flex;
  flex-direction: column;
  justify-content: center;

  background-color: white;
  padding: 0 70px 0px 70px;
  width: 300px;
  height: 550px;
  border-radius: 12px;

  box-shadow: 10px 10px 10px #d1d9e6;
}

.header {
  font-size: 34px;
  font-weight: bold;
  margin-bottom: 35px;
  color: #181818;
  /* border-bottom: #cac9c9 solid 1px; */
}

label {
  width: 95px;
  font-size: 14px;
  color: black;
  text-align: left;
  vertical-align: middle;

}

.form-group {
  margin-top: 15px;
}

.form-group label {
  display: block;
  font-weight: bold;
  margin: 5px 0 2px 0;
  color: #434040;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 12px;
}

#feedback-type {
  height: 25px;
}

.form-group select {
  display: block;
  width: 100%;
  height: 26px;
  border-radius: 4px;
  padding: 0 0 0 5px;
  font-size: 12px;
  background-color: white;
}


.file-upload {
  margin-top: 10px;
  position: relative;
}

#icon {
  position: absolute;
  top: 32px;
  right: 10px;
  cursor: pointer;
}

.alertMessage {
  width: 100%;
  height: 12px;
  text-align: center;
  font-size: 12px;
  color: red;
  margin-top: 20px;
}

.tips {
  margin-top: 2px;
  font-size: 10px;
  text-align: left;
}

button {
  position: relative;
  width: 100%;
  height: 40px;
  border-radius: 25px;
  margin-top: 25px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  letter-spacing: 2px;
  background-color: var(--login-color);
  color: #f9f9f9;
  cursor: pointer;
}

button:hover {
  box-shadow: 4px 4px 6px 0 rgb(255 255 255 / 50%),
    -4px -4px 6px 0 rgb(116 125 136 / 50%),
    inset -4px -4px 6px 0 rgb(255 255 255 / 20%),
    inset 4px 4px 6px 0 rgb(0 0 0 / 40%);
}
</style>
